var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bleed-margin-view" }, [
    _c("div", { staticClass: "bleed-margin-view-image-container" }, [
      _c("div", { staticClass: "bleed-margin-view-image-bleed-margin" }),
      _c("img", {
        staticClass: "bleed-margin-view-image",
        attrs: { src: _vm.imageUrl },
      }),
    ]),
    _c("div", { staticClass: "bleed-margin-view-description" }, [
      _vm._v(_vm._s(_vm.$t("views.bleedMargin.description"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }